import { axiosApi } from "./helper";

export function getOneHrCategories() {
  return axiosApi("categories_onehr", {}, "get");
}

export function getOneHrCategory(code) {
  return axiosApi(`categories_onehr/${code}`, {}, "get");
}

export function getOneHrCourses(code) {
  return axiosApi(`courses_onehr/category/${code}`, {}, "get");
}

export function getOneHrCourse(id) {
  return axiosApi(`courses_onehr/${id}`, {}, "get");
}

export function getOneHrCourseProgress(id) {
  return axiosApi(`courses_onehr/progress/${id}`, {}, "get");
}
